import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { deepClone } from "appworks/utils/collection-utils";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class ThemeGridSizeResult extends Result {
    public resultType: string = "ThemeGridSizeResult";
    public startSize: number[];
    public endSize: number[];
}

export class ThemeGridSizeResultBuilder implements ResultBuilder {
    public filter(data: any, record: Record): boolean {
        return record instanceof FreespinRecord && data.type === "freeSpin";
    }

    public build(record: SpinRecord, data: any, additionalData?: any): Result[] {
        const result = new ThemeGridSizeResult();

        result.endSize = record.grid.map((val) => val.length);

        result.startSize = deepClone(result.endSize);
        const harpoonLocations = data.coLocations || [];
        for (const loc of harpoonLocations) {
            result.startSize[loc[0]]--;
        }

        return [result];
    }

}
